/* eslint-disable */
import { AREA } from './parse';

let province = [];
let city = [];
let area = [];

for (let key in AREA.province_list) {
  const item = {
    Code: key,
    Id: key,
    Name: AREA.province_list[key],
    ParentCode: '',
    ParentId: ''
  };
  province.push(item);
}

for (let key in AREA.city_list) {
  const provinceCode = key.slice(0, 2);
  const item = {
    Code: key,
    Id: key,
    Name: AREA.city_list[key],
    ParentCode: provinceCode + '0000',
    ParentId: provinceCode + '0000'
  };
  city.push(item);
}

for (let key in AREA.area_list) {
  const cityCode = key.slice(0, 4);
  const item = {
    Code: key,
    Id: key,
    Name: AREA.area_list[key],
    ParentCode: cityCode + '00',
    ParentId: cityCode + '00'
  };
  area.push(item);
}

const data = [...province, ...city, ...area];

export default data;



// WEBPACK FOOTER //
// ./~/vue-xpc/src/libs/address/address.js